import React, { useRef, useState, Fragment, useEffect } from 'react';
import classNames from 'classnames';
import { Formik } from 'formik';
import CollapsibleText from '../CollapsibleText';
import Spinner from '../Spinner';
import Alert from '../Alert';
import Field from '../Forms/field';

const CommentForm = (props) => {
  //let ctrls = [];
  // validate = this.validate.bind(this);
  // handleSubmit = this.handleSubmit.bind(this);

  const collapsible = useRef();
  const [isOpen, setIsOpen] = useState(false);
  //const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [text, setText] = useState(null);
  const [title, setTitle] = useState(null);
  const [showSubmitForm, setShowSubmitForm] = useState(false);

  const handleFocus = (name = '') => {
    if (!name) return;

    const elmToFocus = document.getElementById(name);
    if (elmToFocus) {
      elmToFocus.focus();
    }
  };

  useEffect(() => {
    if (isOpen && success !== true) {
      if (collapsible.current) {
        collapsible.current.extendsContent();
      }
      if (props.FeedbackForm.CommentLabel) {
        handleFocus('comment');
      }
    }
  }, [isOpen, showSubmitForm]);

  const handleClick = () => {
    //Trigger scroll event for anchor navigation
    const e = document.createEvent('Event');
    e.initEvent('scroll', true, true);
    window.dispatchEvent(e);

    setIsOpen(!isOpen);
    setSuccess(null);
    setText(null);
    setTitle(null);
  };

  const submitForm = (data) =>
    fetch(props.FeedbackForm.Url, {
      method: 'POST',
      body: data,
    }).then((response) => {
      if (!response.ok) throw new Error(response.status);
      if (response.status !== 200) throw new Error(response.statusText);
      return response.json();
    });

  const handleSubmit = (values, { setSubmitting }) => {
    setSuccess(null);
    setText(null);
    setTitle(null);

    //setIsLoading(true);

    const data = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      data.append(key, value);
    });

    submitForm(data)
      .then((response) => {
        setSubmitting(false);

        setSuccess(response.Success);
        setText(response.Text);
        setTitle(response.Title);

        //setIsLoading(false);
      })
      .catch(() => {
        setSubmitting(false);

        setSuccess(false);

        setTitle('Error');

        //setIsLoading(false);
      });
  };

  const showForm = () => {
    setShowSubmitForm(true);
  };
  const hideForm = () => {
    setShowSubmitForm(false);
  };

  const validate = (values) => {
    const { FeedbackForm } = props;

    const errors = {};
    // Validate email

    if (
      FeedbackForm.EmailLabel &&
      values.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
    ) {
      errors.email = 'email';
    }
    // Validate subject (is required)
    if (!values.subject && FeedbackForm.SubjectLabel) {
      errors.subject = 'required';
    }

    if (!values.comment && FeedbackForm.CommentLabel) {
      errors.comment = 'required';
    }

    if (errors) {
      const firstError = Object.keys(errors)[0];
      handleFocus(firstError);
    }

    return errors;
  };

  const SubmitForm = () => {
    const { FeedbackForm, HsaId, PageUrl } = props;
    const initialValues = {
      user: '',
      url: PageUrl,
      hsaid: HsaId || '',
    };
    if (FeedbackForm.SubjectLabel) initialValues.subject = '';
    if (FeedbackForm.EmailLabel) initialValues.email = '';
    if (FeedbackForm.CommentLabel) initialValues.comment = '';

    return (
      <Fragment>
        <div className="contact-card-comment__success" aria-live="polite">
          {success && (
            <Fragment>
              {title && <h3>{title}</h3>}
              <div dangerouslySetInnerHTML={{ __html: text }} />
            </Fragment>
          )}
        </div>

        {success !== true && (
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            validate={validate}
            onSubmit={handleSubmit}
            initialValues={initialValues}
          >
            {(formik) => (
              <form noValidate method="post" onSubmit={formik.handleSubmit}>
                <fieldset>
                  <legend className="show-for-sr">{FeedbackForm.Title}</legend>

                  <input
                    type="hidden"
                    name="hsaid"
                    value={formik.values.hsaid}
                  />

                  {/*Honeypot for bots*/}
                  <input
                    className="contact-card-comment__protected"
                    type="text"
                    name="user"
                    defaultValue={formik.values.user}
                  />

                  <input type="hidden" name="url" value={formik.values.url} />

                  {FeedbackForm.SubjectLabel && (
                    <Fragment>
                      <label htmlFor="subject">
                        {FeedbackForm.SubjectLabel}
                      </label>
                      <Field
                        component="input"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        name="subject"
                        type="text"
                        isValid={!formik.errors.subject}
                        isTouched={formik.touched.subject}
                        className="c-forms__input"
                        value={formik.values.subject}
                        errorType={formik.errors.subject}
                        errorMessages={{
                          required: FeedbackForm.ValidationRequired,
                        }}
                      />
                    </Fragment>
                  )}

                  {FeedbackForm.CommentLabel && (
                    <Field
                      component="textarea"
                      required={true}
                      isValid={!formik.errors.comment}
                      isTouched={formik.touched.comment}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.comment}
                      className="c-forms__textarea"
                      name="comment"
                      errorType={formik.errors.comment}
                      errorMessages={{
                        required: FeedbackForm.ValidationRequired,
                      }}
                    >
                      <label htmlFor="comment">
                        {FeedbackForm.CommentLabel}
                      </label>
                    </Field>
                  )}

                  {FeedbackForm.EmailLabel && (
                    <Fragment>
                      <label htmlFor="email">{FeedbackForm.EmailLabel}</label>
                      <Field
                        component="input"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        isValid={!formik.errors.email}
                        isTouched={formik.touched.email}
                        name="email"
                        type="email"
                        autoComplete="email"
                        className="c-forms__input"
                        value={formik.values.email}
                        errorType={formik.errors.email}
                        errorMessages={{
                          email: FeedbackForm.ValidationEmailFormat,
                        }}
                      />
                    </Fragment>
                  )}

                  <div aria-live="assertive">
                    {success === false && (
                      <Alert
                        type="warning"
                        Modifiers={{
                          'c-alert--small': true,
                        }}
                      >
                        <div>
                          {title && <h3>{title}</h3>}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: text,
                            }}
                          />
                        </div>
                      </Alert>
                    )}
                  </div>

                  <div className="contact-card-comment__content__footer">
                    <button
                      type="submit"
                      disabled={formik.isSubmitting}
                      data-cy="ui-comment-form-submit-btn"
                      className={classNames({
                        'c-forms__button': true,
                        'c-forms__button--is-loading': formik.isSubmitting,
                      })}
                    >
                      <span className="c-forms__button__text">
                        {FeedbackForm.SendButtonLabel}
                      </span>
                      <Spinner />
                    </button>
                    {FeedbackForm.HasLinkList && (
                      <button
                        className="c-forms__button c-forms__button--secondary"
                        onClick={() => hideForm()}
                      >
                        <span className="c-forms__button__text">
                          {FeedbackForm.CancelButtonLabel}
                        </span>
                      </button>
                    )}
                  </div>
                </fieldset>
              </form>
            )}
          </Formik>
        )}
      </Fragment>
    );
  };

  const ToggleFormButton = () => {
    const { FeedbackForm } = props;

    return (
      <h2>
        <button
          aria-controls="contact-card-comment"
          aria-expanded={isOpen}
          className={classNames({
            'contact-card-comment__header': true,
            'contact-card-comment__header--is-open': isOpen,
          })}
          onClick={() => handleClick()}
          type="button"
          data-cy="comment-form-toggle-btn"
        >
          <span>{FeedbackForm.Title}</span>
          <i
            className={classNames({
              'contact-card-comment__header__chevron': true,
              'contact-card-comment__header__chevron--is-expanded': isOpen,
            })}
          />
        </button>
      </h2>
    );
  };

  const LinkList = () => {
    const { FeedbackForm } = props;

    return (
      <div
        className={classNames({
          'contact-card-comment-link-list': true,
          'contact-card-comment-link-list--is-hidden': showSubmitForm,
        })}
      >
        <h3 className="contact-card-comment-link-list__title">
          {FeedbackForm.LinkListTitle}
        </h3>
        <div className="contact-card-comment-link-list__wrapper">
          <ul className="contact-card-comment-link-list__list">
            {FeedbackForm.Links.map((item, i) => {
              return (
                <li
                  className="contact-card-comment-link-list__list-item"
                  key={i}
                >
                  {item.IsForm ? (
                    <button
                      className="contact-card-comment-link-list__list-item__link"
                      data-cy="contact-card-feedbackform-btn"
                      onClick={() => showForm()}
                    >
                      <span>{item.Title}</span>
                    </button>
                  ) : (
                    <a
                      href={item.Url}
                      className="contact-card-comment-link-list__list-item__link"
                    >
                      <span>{item.Title}</span>
                    </a>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  };

  const { FeedbackForm } = props;

  if (!FeedbackForm) return null;

  return (
    <div
      className={classNames({
        'contact-card-comment': true,
        ...props.Modifiers,
      })}
      data-cy="comment-form"
    >
      {ToggleFormButton()}
      <div
        aria-hidden={!isOpen}
        id="contact-card-comment"
        className={classNames({
          'contact-card-comment__content': true,
          'contact-card-comment__content--is-open': isOpen,
        })}
      >
        {success !== true && (
          <Fragment>
            {FeedbackForm.Text && FeedbackForm.Text.length > 400 ? (
              <CollapsibleText
                ref={collapsible}
                buttonReadMoreText="Visa mer text"
                buttonReadLessText="Visa mindre text"
                buttonChildren={
                  <i
                    className={classNames({
                      'contact-card-comment__content-expand': true,
                    })}
                  />
                }
                className="contact-card-comment__content__text"
              >
                <div dangerouslySetInnerHTML={{ __html: FeedbackForm.Text }} />
              </CollapsibleText>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: FeedbackForm.Text }} />
            )}
          </Fragment>
        )}

        {showSubmitForm && SubmitForm()}

        {FeedbackForm.HasLinkList ? LinkList() : SubmitForm()}

        <div
          className="contact-card-comment__content__footer-text"
          dangerouslySetInnerHTML={{ __html: FeedbackForm.ExtraText }}
        ></div>
      </div>
    </div>
  );
};

export default CommentForm;
